export const validateMessages = {
  required: 'Required',
  types: {
    email: 'Invalid'
  }
};

/**
 * @deprecated
 * @description We are no longer checking against names as the may vary a lot. Use SX_ADMIN_ENABLED_ACCOUNTS_IDS instead
 */
export const SX_ADMIN_ACCOUNTS = ['SightX', 'Devsu', 'Frontier 7'];

const whiteSpacesPatern = new RegExp(/^[^\s]+(\s+[^\s]+)*$/);

export const nameFieldsValidation = { pattern: whiteSpacesPatern , message: 'Invalid' };
